import React from 'react';
import { Box, Typography, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export interface PrismicBannerProps {
  title: string;
  body: string;
  backgroundColor: string;
  textColor?: string;
  className?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  bannerContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '16px 20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
  bannerTitle: {
    margin: '0 0 8px 0',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: 1.3,
  },
  bannerBody: {
    margin: 0,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.4,
    opacity: 0.95,
    '& p': {
      margin: '0 0 8px 0',
      '&:last-child': {
        margin: 0,
      },
    },
    '& a': {
      color: 'inherit',
      textDecoration: 'underline',
    },
    '& strong': {
      fontWeight: 600,
    },
    '& em': {
      fontStyle: 'italic',
    },
  },
}));

export const PrismicBanner: React.FC<PrismicBannerProps> = ({ title, body, backgroundColor, textColor = '#ffffff', className }) => {
  const classes = useStyles();

  return (
    <Box
      className={`${classes.bannerContainer} ${className || ''}`}
      style={{
        backgroundColor,
        color: textColor,
      }}
    >
      <Typography className={classes.bannerTitle} style={{ color: textColor }} component='h3'>
        {title}
      </Typography>
      <Box className={classes.bannerBody} style={{ color: textColor }} dangerouslySetInnerHTML={{ __html: body }} />
    </Box>
  );
};

export default PrismicBanner;
